import './Skeleton.css';

export default function Skeleton() {
  return (
    <div className="skeleton-page" aria-label="Loading">
      <div className="container">
        <div className="skeleton-header">
          <div className="skeleton-line skeleton-eyebrow" />
          <div className="skeleton-line skeleton-title" />
        </div>
        <div className="skeleton-body">
          <div className="skeleton-line skeleton-text" />
          <div className="skeleton-line skeleton-text" />
          <div className="skeleton-line skeleton-text skeleton-text-short" />
        </div>
      </div>
    </div>
  );
}
